export const errorPageCriticalStyles = `
.error-page {
  align-items: center;
  background-color: #f3f5f8;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: 0;
  min-height: 100vh;
  padding: 24px;
}

.error-page:focus {
  outline: none;
}

.error-page__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 560px;
  text-align: center;
  width: 100%;
}

.error-page__title {
  color: #ff7b29;
  font-family: Poppins, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0;
}

.error-page__context-heading {
  color: #00204b;
  font-family: Poppins, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
}

.error-page__description,
.error-page__guidance {
  color: #00204b;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
}

.error-page__actions {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.error-page__home-link {
  align-items: center;
  background-color: #ff7b29;
  border-radius: 28px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  justify-content: center;
  line-height: 16px;
  padding: 16px 24px;
  text-decoration: none;
  white-space: nowrap;
}

.error-page__home-link:hover {
  background-color: #ffaa79;
  color: #ffffff;
}

.error-page__home-link:active {
  background-color: #00204b;
  color: #ffffff;
}

.error-page__dev-details {
  margin-top: 16px;
  text-align: left;
}

.error-page__dev-details-summary {
  color: #00204b;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.error-page__dev-details-content {
  background-color: #ffffff;
  border-radius: 8px;
  color: #00204b;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 8px;
  overflow-wrap: anywhere;
  overflow-x: auto;
  padding: 16px;
  white-space: pre-wrap;
}
`;
